// מקור האמת למסלולי המנוי במסך "הצטרפו לקהילת המנויים" (SubscriptionOptions.vue).
// כרגע ה-getter subscriptionOptions ב-store/index.ts מחזיר נתונים מכאן בלבד (לא מהשרת).
//
// שדות קריטיים שהמסך מסתמך עליהם ולא בהכרח קיימים בשרת:
//   - more_info.feature_ids   -> אילו רוביקות (V) מופיעות לכל מסלול (hasFeature ב-SubscriptionOptions.vue)
//   - more_info.external_link -> מסלול עם לינק חיצוני (הכפתור "בחירה" מפנה החוצה במקום לעגלה)
// אם בעתיד עוברים לטעינה מהשרת (apiSubscriptions) — יש לוודא שהשדות והמסלולים האלה
// מוגדרים גם בצד השרת, אחרת המסך יישבר.
export default [
	{
		"id": "029eadfa-c9f4-4a7f-9399-7452734b4892",
		"title": "מנוי שיבולת - שנתי",
		"price": 579,
		"image_path": "sellameir/%D7%A9%D7%99%D7%91%D7%95%D7%9C%D7%AA%20PNG_1_2.png",
		"release_date": "2025-07-09T09:49:11.140716",
		"categories": [],
		"featured": true,
		"product_type": "Subscription",
		"visibility": "Public",
		"subscription_cycle": "Annually",
		"more_info": {
			"feature_ids": ["translated_books", "magazine", "breakthrough_book"]
		}
	},
	{
		"id": "44071fe8-c828-47b7-886e-f21df965ddec",
		"title": "מנוי שיבולת פלוס שנתי",
		"price": 939,
		"image_path": "sellameir/%D7%A9%D7%99%D7%91%D7%95%D7%9C%D7%AA%20PNG_1_3.png",
		"release_date": "2025-07-09T09:49:53.269062",
		"categories": [],
		"featured": false,
		"product_type": "Subscription",
		"visibility": "Public",
		"subscription_cycle": "Annually",
		"more_info": {
			"feature_ids": ["translated_books", "magazine", "breakthrough_book", "new_books"]
		}
	},
	{
		"id": "29fd8d32-ad9b-4810-89cc-53bb89fc18c7",
		"title": "מנוי שיבולת",
		"price": 39,
		"image_path": "sellameir/%D7%A9%D7%99%D7%91%D7%95%D7%9C%D7%AA%20PNG_1_2.png",
		"release_date": "2025-01-01T00:00:00",
		"categories": [],
		"more_info": {
			"billing_date": 1,
			"feature_ids": ["translated_books", "magazine", "breakthrough_book"]
		},
		"featured": true,
		"product_type": "Subscription",
		"visibility": "Public",
		"subscription_cycle": "Monthly",
		"subscription_billing_date": 1
	},
	{
		"id": "b0f430e3-afda-446e-b963-69239f4b36a1",
		"title": "מנוי שיבולת פלוס",
		"price": 69,
		"image_path": "sellameir/%D7%A9%D7%99%D7%91%D7%95%D7%9C%D7%AA%20PNG_1.png",
		"release_date": "2025-05-26T06:28:01.262427",
		"categories": [],
		"more_info": {
			"billing_date": 1,
			"feature_ids": ["translated_books", "magazine", "breakthrough_book", "new_books"]
		},
		"featured": false,
		"product_type": "Subscription",
		"visibility": "Public",
		"subscription_cycle": "Monthly",
		"subscription_billing_date": 1
	},
	{
		"id": "shomer-saf-shibolet-plus",
		"title": "שומר סף ושיבולת פלוס",
		"price": 69,
		"image_path": "sellameir/%D7%A9%D7%99%D7%91%D7%95%D7%9C%D7%AA%20PNG_1.png",
		"release_date": "2025-05-26T06:28:01.262427",
		"categories": [],
		"more_info": {
			"billing_date": 1,
			"feature_ids": ["translated_books", "magazine", "breakthrough_book", "new_books", "shomer_saf"],
			// TODO: להחליף את ה-placeholder "#" בכתובת ה-URL האמיתית של הלינק החיצוני
			"external_link": "https://www.peach-in.com/cmp/c1R2bwiar"
		},
		"featured": false,
		"product_type": "Subscription",
		"visibility": "Public",
		"subscription_cycle": "Monthly",
		"subscription_billing_date": 1
	}
]
